import React from "react";
import './Whastapp.css'
import {
  FaWhatsapp
} from "react-icons/fa";

function Whastapp() {
  return (
      <div id="qlwapp" className="qlwapp-free qlwapp-button qlwapp-bottom-right qlwapp-all qlwapp-rounded qlwapp-js-ready desktop">
        <div className="qlwapp-container">
          
          <a className="qlwapp-toggle" data-action="open" data-phone="393923474801" data-message="Salve la contatto dal sito Baes Studio" href="https://api.whatsapp.com/send?phone=393923474801&text=Salve%20la%20contatto%20dal%20sito%20Baes%20Studio" target="_blank">
                    <FaWhatsapp/>
                    <span className="qlwapp-text" style={{padding:"5px"}}> Come possiamo aiutarti?</span>
                </a>
        </div>
      </div>
  )
}

export default Whastapp